import { Clock, Check, Edit, Plus, Mail } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

const EVENT_CONFIG = {
  created: { icon: Plus, color: 'text-primary', label: 'Created' },
  edited: { icon: Edit, color: 'text-muted-foreground', label: 'Edited' },
  email_sent: { icon: Mail, color: 'text-blue-500', label: 'Email sent' },
  task_completed: { icon: Check, color: 'text-green-600', label: 'Task done' },
  default: { icon: Clock, color: 'text-muted-foreground', label: 'Updated' },
};

function formatTime(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  const now = new Date();
  const mins = Math.floor((now - d) / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function ActivityTimeline({ events, loading }) {
  if (loading) {
    return (
      <div className="space-y-4 py-2">
        {[1,2,3].map(i => (
          <div key={i} className="flex gap-3">
            <Skeleton className="w-6 h-6 rounded-full shrink-0" />
            <div className="flex-1 space-y-1.5">
              <Skeleton className="h-3 w-3/4" />
              <Skeleton className="h-2.5 w-1/2" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!events || events.length === 0) {
    return (
      <div className="py-4 text-center">
        <Clock size={18} className="mx-auto text-muted-foreground mb-2" />
        <p className="text-xs text-muted-foreground">No activity yet</p>
      </div>
    );
  }

  const sorted = [...events].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

  return (
    <div className="relative pl-5">
      <div className="absolute left-[9px] top-0 bottom-0 w-px bg-border" />
      <div className="space-y-4">
        {sorted.map((event, i) => {
          const cfg = EVENT_CONFIG[event.event] || EVENT_CONFIG.default;
          const Icon = cfg.icon;
          return (
            <div key={`${event.event}-${event.timestamp}-${i}`} className="relative flex gap-3">
              <div className="absolute -left-5 w-[18px] h-[18px] rounded-full border-2 border-background bg-secondary flex items-center justify-center shrink-0 mt-0.5">
                <Icon size={9} className={cfg.color} />
              </div>
              <div className="min-w-0 pb-1">
                <p className="text-xs text-foreground/75 leading-relaxed">{event.detail}</p>
                <p className="text-[10px] text-muted-foreground mt-0.5 font-mono">{formatTime(event.timestamp)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
